import React, { useCallback, useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { CRM_CHART_THEME } from "../crmAnalytics.constants";
import { ChartMetric } from "../../../../cores/analytics/interface/ChartMetric";
import { charBasicDataset, pieChartBasicOptions } from "../../../utils/chartsUtils";

interface Props extends ChartMetric {
  colors?: string[];
  onElementClick?: (element: any) => void;
}

const donutOptions = {
  ...pieChartBasicOptions,
  cutoutPercentage: 62,
  elements: {
    arc: {
      borderWidth: 2,
      borderColor: "#ffffff",
    },
  },
};

export const CrmDonutChart = ({
  labels,
  datasets,
  onElementClick,
  colors = CRM_CHART_THEME,
}: Props) => {
  const getColor = useCallback(
    (index: number) => colors[index % colors.length],
    [colors]
  );

  const chartColors = useMemo(
    (): string[] => datasets[0]?.data.map((_, index) => getColor(index)) || [],
    [datasets, getColor]
  );

  const data = useMemo(
    () => ({
      labels,
      datasets: datasets.map(({ label, data, fill, type }) => ({
        ...charBasicDataset,
        label,
        borderColor: chartColors,
        backgroundColor: chartColors,
        fill,
        type,
        data: [...data],
      })),
    }),
    [chartColors, datasets, labels]
  );

  return (
    <Doughnut
      data={data}
      options={donutOptions}
      getElementAtEvent={onElementClick}
    />
  );
};
